// src/models/NewBranch.jsx
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

const emptyForm = {
  branch_id: "",
  branch_name: "",
  branch_contact_no: "",
  branch_address: "",
  branch_phone_no: "",
  branch_owner_name: "",
  branch_owner_phone: "",
  branch_commission: "",
  branch_commission_type: "percent",
};

const NewBranch = ({ item, onAddBranch }) => {
  const [formData, setFormData] = useState(emptyForm);
  // dynamic extra fields: each = { label, level, value }
  const [extraFields, setExtraFields] = useState([]);
  const [ldata, setLdata] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ---- extra field helpers ----
  const addExtraField = () =>
    setExtraFields((prev) => [...prev, { label: "", level: "", value: "" }]);

  const removeExtraField = (idx) =>
    setExtraFields((prev) => prev.filter((_, i) => i !== idx));

  const updateExtraField = (idx, key, val) =>
    setExtraFields((prev) =>
      prev.map((row, i) => (i === idx ? { ...row, [key]: val } : row))
    );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.branch_name.trim()) {
      toast.error("Branch name is required");
      return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("branch_id", formData.branch_id || "");
      fd.append("branch_name", formData.branch_name);
      fd.append("branch_contact_no", formData.branch_contact_no);
      fd.append("branch_address", formData.branch_address);
      fd.append("branch_phone_no", formData.branch_phone_no);
      fd.append("branch_owner_name", formData.branch_owner_name);
      fd.append("branch_owner_phone", formData.branch_owner_phone);
      fd.append("branch_commission", formData.branch_commission || 0);
      fd.append("branch_commission_type", formData.branch_commission_type);
      // send only rows that have a label
      const cleaned = extraFields.filter((r) => (r.label || "").trim() !== "");
      fd.append("extra_fields", JSON.stringify(cleaned));
      if (ldata?.user_id) fd.append("branch_cre_by", ldata.user_id);

      const res = await axios.post(
        AppConst.BASE_URL + AppConst.addBranchUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data && res.data.status) {
        toast.success(res.data.success || "Saved");
        document.getElementById("closeBtBranch").click();
        onAddBranch && onAddBranch();
      } else {
        toast.error(res.data?.success || "Failed");
      }
    } catch (err) {
      console.error("save branch error", err);
      toast.error("Failed");
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      try {
        setLdata(JSON.parse(stored));
      } catch (_) {}
    }

    if (item) {
      // editing an existing branch
      setFormData({
        branch_id: item.branch_id || "",
        branch_name: item.branch_name || "",
        branch_contact_no: item.branch_contact_no || "",
        branch_address: item.branch_address || "",
        branch_phone_no: item.branch_phone_no || "",
        branch_owner_name: item.branch_owner_name || "",
        branch_owner_phone: item.branch_owner_phone || "",
        branch_commission: item.branch_commission || "",
        branch_commission_type: item.branch_commission_type || "percent",
      });
      // map DB rows -> {label, level, value}
      const ex = (item.extra_fields || []).map((r) => ({
        label: r.bef_field_label || "",
        level: r.bef_field_level || "",
        value: r.bef_field_value || "",
      }));
      setExtraFields(ex);
    } else {
      setFormData(emptyForm);
      setExtraFields([]);
    }
  }, [item]);

  return (
    <div
      className="modal fade"
      id="showBranchModal"
      tabIndex="-1"
      aria-labelledby="branchModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-light p-3">
            <h5 className="modal-title" id="branchModalLabel">
              {formData.branch_id ? "Edit Branch" : "Add Branch"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="close-branch-modal"
            ></button>
          </div>

          <form className="tablelist-form" onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row gy-3">
                <div className="col-md-6">
                  <label className="form-label">
                    Branch Name <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    name="branch_name"
                    value={formData.branch_name}
                    onChange={handleChange}
                    placeholder="Branch name"
                    type="text"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Contact No</label>
                  <input
                    className="form-control"
                    name="branch_contact_no"
                    value={formData.branch_contact_no}
                    onChange={handleChange}
                    placeholder="Contact number"
                    type="text"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Phone No</label>
                  <input
                    className="form-control"
                    name="branch_phone_no"
                    value={formData.branch_phone_no}
                    onChange={handleChange}
                    placeholder="Phone number"
                    type="text"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Owner Name</label>
                  <input
                    className="form-control"
                    name="branch_owner_name"
                    value={formData.branch_owner_name}
                    onChange={handleChange}
                    placeholder="Owner name"
                    type="text"
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Owner Phone No</label>
                  <input
                    className="form-control"
                    name="branch_owner_phone"
                    value={formData.branch_owner_phone}
                    onChange={handleChange}
                    placeholder="Owner phone"
                    type="text"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Commission</label>
                  <input
                    className="form-control"
                    name="branch_commission"
                    value={formData.branch_commission}
                    onChange={handleChange}
                    placeholder="0"
                    type="number"
                    min="0"
                    step="0.01"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Commission Type</label>
                  <select
                    className="form-select"
                    name="branch_commission_type"
                    value={formData.branch_commission_type}
                    onChange={handleChange}
                  >
                    <option value="percent">Percent (%)</option>
                    <option value="fix">Fixed (₹)</option>
                  </select>
                </div>

                <div className="col-md-12">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    name="branch_address"
                    value={formData.branch_address}
                    onChange={handleChange}
                    placeholder="Address"
                    rows="2"
                  ></textarea>
                </div>

                {/* ---------- EXTRA FIELDS (with level) ---------- */}
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-center border-top pt-3">
                    <h6 className="mb-0">
                      <i className="ri-list-settings-line me-1"></i> Extra Fields
                    </h6>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={addExtraField}
                    >
                      <i className="ri-add-line"></i> Add Field
                    </button>
                  </div>
                </div>

                {extraFields.length === 0 && (
                  <div className="col-12">
                    <div className="text-muted small">
                      No extra fields. Click “Add Field” to create one.
                    </div>
                  </div>
                )}

                {extraFields.map((row, idx) => (
                  <div className="col-12" key={idx}>
                    <div className="row g-2 align-items-end">
                      <div className="col-md-4">
                        <label className="form-label small mb-1">Field Name</label>
                        <input
                          className="form-control"
                          placeholder="e.g. GST No"
                          value={row.label}
                          onChange={(e) =>
                            updateExtraField(idx, "label", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small mb-1">Level</label>
                        <input
                          className="form-control"
                          placeholder="e.g. Primary"
                          value={row.level}
                          onChange={(e) =>
                            updateExtraField(idx, "level", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small mb-1">Value</label>
                        <input
                          className="form-control"
                          placeholder="Value"
                          value={row.value}
                          onChange={(e) =>
                            updateExtraField(idx, "value", e.target.value)
                          }
                        />
                      </div>
                      <div className="col-md-1">
                        <button
                          type="button"
                          className="btn btn-outline-danger w-100"
                          onClick={() => removeExtraField(idx)}
                          title="Remove"
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  id="closeBtBranch"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-success" disabled={saving}>
                  {saving
                    ? "Saving..."
                    : formData.branch_id
                    ? "Update"
                    : "Add"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewBranch;